import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {NavigationUtils} from "../utils/navigation-utils";

@Injectable({
  providedIn: 'root',
})
export class RouteNotFoundGuard implements CanActivate {
  constructor() {
  }

  canActivate(): boolean | UrlTree {
    NavigationUtils.navigateToGwoLoginPage()
    return false;
  }
}
